/**
 * Keeps the citizen's `users.timezone` on this device's zone, so quiet hours
 * (evaluated server-side) mean the hours where they actually are. Renders
 * nothing — see `useDeviceTimezoneSync`.
 */
import { getDeviceTimeZone } from '@tonnie/locale';
import { useDeviceTimezoneSync } from '@tonnie/sdk';

export function DeviceTimezoneSync(): null {
  useDeviceTimezoneSync(getDeviceTimeZone());
  return null;
}
